/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import './badge.scss';
import { X } from 'react-feather';
import clsx from 'clsx';
import Image from '../image';
import Icon, { IconColors, IconSizes } from '../icon';

const BadgeTypes = {
  GRAY: 'bdg-gray',
  PRIMARY: 'bdg-primary',
  ERROR: 'bdg-error',
  WARNING: 'bdg-warning',
  SUCCESS: 'bdg-success',
  BLUE: 'bdg-blue',
};

const BadgeSizes = {
  SMALL: 'size-s',
  MEDIUM: 'size-m',
  LARGE: 'size-l',
};

const IconColorBadgeTypeMap = {
  [BadgeTypes.GRAY]: IconColors.GREY,
  [BadgeTypes.PRIMARY]: IconColors.PRIMARY,
  [BadgeTypes.ERROR]: IconColors.ERROR,
  [BadgeTypes.WARNING]: IconColors.WARNING,
  [BadgeTypes.SUCCESS]: IconColors.SUCCESS,
  [BadgeTypes.BLUE]: IconColors.BLUE,
};

const Badge = React.forwardRef(({
  label, type, size, image, showDot, onClick, className, showRemove, renderIcon,
}, ref) => {
  const classNames = clsx('badge-cont', type, size, className);

  const getDot = () => {
    if (!image && !renderIcon && showDot) {
      return <div className="badge-dot" />;
    }
    return null;
  };

  const getImage = () => {
    if (image) {
      return <Image className="badge-image" src={image} />;
    }
    return null;
  };

  const getCross = () => {
    if (showRemove) {
      return (
        <Icon
          icon={X}
          size={IconSizes.SMALL}
          color={IconColors.LIGHT}
          className="badge-image-cross"
        />
      );
    }
    return null;
  };

  return (
    <div className={classNames} key={label} onClick={() => onClick()} ref={ref}>
      {getDot()}
      {getImage()}
      {renderIcon && (
      <span className="badge-icon">
        {renderIcon({ color: IconColorBadgeTypeMap[type], size })}
      </span>
      )}
      <span className="badge-label">{label}</span>
      {getCross()}
    </div>
  );
});

const BadgeProps = {
  label: PropTypes.string,
  type: PropTypes.oneOf(Object.values(BadgeTypes)),
  size: PropTypes.oneOf(Object.values(BadgeSizes)),
  renderIcon: PropTypes.func,
  image: PropTypes.string,
  showDot: PropTypes.bool,
  showRemove: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  ref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

const BadgeDefaultProps = {
  type: BadgeTypes.PRIMARY,
  size: BadgeSizes.MEDIUM,
  renderIcon: null,
  image: '',
  showDot: true,
  showRemove: false,
  className: '',
  onClick: () => {},
  label: '',
  ref: null,
};

Badge.propTypes = BadgeProps;

Badge.defaultProps = BadgeDefaultProps;

export {
  Badge as default,
  BadgeTypes,
  BadgeSizes,
};
